import {
    Box,
    Container,
    ImageList,
    ImageListItem,
    Stack,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import React from 'react';
import Background from '../../assets/Images/heroBackground.webp';
import careerMock from '../../assets/Images/CareerMockZoom.webp';
import logo from '../../assets/Images/logo.webp';
// import BackgroundCareer from '../../assets/Images/'

const Career = () => {
    const theme = useTheme();
    const medium = useMediaQuery(theme.breakpoints.down('md'));
    const mobile = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <Stack
            position="relative"
            pt={mobile ? '60px' : '80px'}
            pb={mobile ? '60px' : '80px'}
            sx={{
                // bgcolor: '#FCFBF8',
                background:
                    mobile || medium
                        ? 'linear-gradient(114.64deg, #FFF9ED 1.2%, #D5F3FE 97.96%)'
                        : 'linear-gradient(111.74deg, #FDE6FA -0.73%, #D6F0FF 105.17%)',
                backgroundBlendMode: 'overlay'
                // background: linear-gradient(114.64deg, #FFF9ED 1.2%, #D5F3FE 97.96%);
            }}
        >
            <Stack
                position="absolute"
                top={0}
                bottom={0}
                left={0}
                right={0}
                sx={{
                    backgroundImage: `url(${Background})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}
            ></Stack>
            <Container
                maxWidth="xl"
                disableGutters
                sx={{
                    // px: '16px',
                    position: 'relative'
                }}
            >
                {mobile ? (
                    <Stack
                        sx={{
                            // gap: '50px'
                            margin: ''
                        }}
                    >
                        <Stack
                            sx={{
                                // display: 'flex',
                                maxWidth: '700px',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                justifyItems: 'center',
                                gap: '24px',
                                margin: '16px 16px 36px 16px'
                            }}
                        >
                            <Typography
                                sx={{
                                    color: '#464646',
                                    fontFamily: 'CabinetGrotesk-Variable',
                                    fontSize: mobile ? '36px' : '60px',
                                    lineHeight: mobile ? '43px' : '72px',
                                    letterSpacing: '-5%',
                                    fontWeight: 800
                                }}
                            >
                                Your Career Success Indicator
                            </Typography>
                            <Typography
                                color="#747474"
                                fontSize={mobile ? '14px' : '20px'}
                                fontWeight={400}
                                lineHeight={mobile ? '21px' : '30px'}
                                fontFamily="Outfit"
                            >
                                Jobfactor score is a scoring system that
                                combines 62 different data points, including
                                skills, culture fit and value interaction to
                                predict success in employment.
                            </Typography>
                        </Stack>
                        <Box
                            // maxWidth={'817px'}
                            // display={'flex'}
                            // alignContent={'center'}
                            sx={{
                                margin: mobile ? '36px 16px 0 16px' : '0'
                            }}
                        >
                            <img
                                src={careerMock}
                                alt="Blurred screenshot of application, focusing on the jobfactor score"
                                width={mobile ? '100%' : undefined}
                                // height={'auto'}
                            />
                        </Box>
                    </Stack>
                ) : (
                    <Stack
                        maxWidth={'100%'}
                        marginRight={'60px'}
                        marginLeft={'-5%'}
                        position={'relative'}
                    >
                        <Stack
                            flexDirection="row-reverse"
                            alignItems="center"
                            justifyContent={'flex-end'}
                            gap="60px"
                        >
                            <Stack
                                flex={1}
                                sx={{
                                    display: 'flex',
                                    maxWidth: medium ? '100%' : '589px',
                                    flexDirection: medium ? 'row' : 'column',
                                    alignItems: mobile
                                        ? 'center'
                                        : 'flex-start',
                                    justifyContent: 'center',
                                    gap: '36px'
                                    // mb: '16px'
                                }}
                            >
                                <ImageList
                                    sx={{
                                        transition: 'all .4s ease',
                                        mb: '10%',
                                        p: 0
                                    }}
                                    cols={1}
                                >
                                    <ImageListItem>
                                        <img src={logo} alt="logo" />
                                    </ImageListItem>
                                </ImageList>
                                <Typography
                                    sx={{
                                        color: '#464646',
                                        fontFamily: 'CabinetGrotesk-Variable',
                                        fontSize: '60px',
                                        fontStyle: 'normal',
                                        lineHeight: '72px',
                                        letterSpacing: '-3px',
                                        maxWidth: '511px',
                                        fontWeight: 800,
                                        whiteSpace: 'break-spaces'
                                        // overflowWrap: 'break-word'
                                    }}
                                >
                                    Your Career Success Indicator
                                </Typography>
                                <Typography
                                    maxWidth="492px"
                                    color="#747474"
                                    fontSize={'20px'}
                                    fontWeight="300"
                                    lineHeight="30px"
                                    fontFamily="Outfit"
                                    fontStyle="normal"
                                    letterSpacing="0.92px"
                                >
                                    Jobfactor score is a comprehensive scoring
                                    system that combines 62 different data
                                    points, including skills, culture fit and
                                    value interaction to predict success in
                                    employment.
                                </Typography>
                            </Stack>
                            <Stack
                                width={'100%'}
                                maxWidth={'55%'}
                                alignSelf={'flex-start'}
                                data-aos="fade-up"
                                data-aos-duration="1000"
                                data-aos-delay={medium ? '500' : '1300'}
                                sx={{
                                    flexDirection: 'column',
                                    margin: 0
                                }}
                            >
                                <ImageList cols={1} sx={{ m: 0 }}>
                                    <ImageListItem>
                                        <img src={careerMock} alt="Monitor" />
                                    </ImageListItem>
                                </ImageList>
                            </Stack>
                        </Stack>
                    </Stack>
                )}
            </Container>
        </Stack>
    );
};

export default Career;
